import React from 'react'

import { Button } from '@wartek-id/button-v1'
import { useToast } from '@wartek-id/toast'

import { useMediaQueryHelper } from '../hooks/useMediaQueryHelper'

interface IPactButtonProps {
  ctaCopy: string
  checkMark: boolean
  integrityPact: boolean
  HandlePactAccept: (integrityPact: boolean) => void
}

const PactButton = ({
  ctaCopy,
  checkMark,
  integrityPact,
  HandlePactAccept,
}: IPactButtonProps) => {
  const toast = useToast()
  const { isDesktop } = useMediaQueryHelper()
  return (
    <div
      className="bottom-0 py-5 px-4 w-full"
      onClick={() => {
        if (!checkMark)
          toast({
            message: 'Persetujuan di bawah wajib dicentang',
          })
      }}
    >
      <Button
        className="float-right"
        disabled={!checkMark}
        fullWidth={!isDesktop}
        color="black"
        size="lg"
        onClick={() => {
          HandlePactAccept(integrityPact)
        }}
      >
        {ctaCopy}
      </Button>
    </div>
  )
}

export default PactButton
